import { useState } from 'react';
import { Outlet, Link, NavLink } from 'react-router-dom';
import logo from '@/assets/thehubpub_logo.png';
import styles from './Layout.module.css';

function Layout() {
  const [menuOpen, setMenuOpen] = useState(false);
  const year = new Date().getFullYear();

  return (
    <div className={styles.layout}>
      <header className={styles.header}>
        <nav className={styles.nav}>
          <Link to="/" className={styles.logoLink}>
            <img src={logo} alt="The Hub Pub" className={styles.logoImage} />
          </Link>

          <button
            className={`${styles.hamburger} ${menuOpen ? styles.hamburgerOpen : ''}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <span />
            <span />
            <span />
          </button>

          <ul className={`${styles.navLinks} ${menuOpen ? styles.navLinksOpen : ''}`}>
            <li>
              <NavLink
                to="/"
                className={({ isActive }) => isActive ? styles.navLinkActive : styles.navLink}
                onClick={() => setMenuOpen(false)}
                end
              >
                Home
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/about"
                className={({ isActive }) => isActive ? styles.navLinkActive : styles.navLink}
                onClick={() => setMenuOpen(false)}
              >
                About
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/contact"
                className={({ isActive }) => isActive ? styles.navLinkActive : styles.navLink}
                onClick={() => setMenuOpen(false)}
              >
                Contact
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/menu"
                className={({ isActive }) => isActive ? styles.navLinkActive : styles.navLink}
                onClick={() => setMenuOpen(false)}
              >
                Menu
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/parties"
                className={({ isActive }) => isActive ? styles.navLinkActive : styles.navLink}
                onClick={() => setMenuOpen(false)}
              >
                Parties
              </NavLink>
            </li>
            <li>
              <a
                href="https://www.facebook.com/HubPub/"
                className={styles.navLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                Facebook
              </a>
            </li>
          </ul>
        </nav>
      </header>

      <main className={styles.main}>
        <Outlet />
      </main>

      <footer className={styles.footer}>
        <img src={logo} alt="The Hub Pub logo" className={styles.footerLogo} />
        <p className={styles.footerText}>18 Province Street Boston, MA 02108</p>
        <p className={styles.footerText}>Call: 617-227-8952</p>
        <p className={styles.footerText}>Stay Connected</p>
        <nav className={styles.footerSocial}>
          <a href="https://www.facebook.com/HubPub/" target="_blank" rel="noopener noreferrer">
            Facebook
          </a>
        </nav>
        <p className={styles.footerText}>&copy; {year} The Hub Pub</p>
      </footer>
    </div>
  );
}

export default Layout;
